export default __webpack_public_path__ + "static/media/Leah_Carey_AHV_In_Moms_We_Trust.4f22aed3.jpg";